const CTA = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-cyan-500 to-blue-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Study in South Korea?
        </h2>
        <p className="text-xl text-cyan-100 mb-8 max-w-2xl mx-auto">
          Join hundreds of international students who have started their journey
          at top Korean universities. Let us help you apply, get scholarships,
          and settle in Korea.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            className="border-2 border-orange-400 bg-orange-400 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-500 hover:border-orange-500 transition-colors duration-200"
            onClick={() => {
              window.location.href = "/signin";
            }}
          >
            Apply to Korean Universities
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
